import { fetchUserWalletStatus, OnBoardingStatus } from 'lib/models/users';
import { useCallback, useEffect, useState } from 'react';

function useUserWalletStatus(username: string) {
	const [loading, setLoading] = useState<boolean>(true);
	const [status, setStatus] = useState<OnBoardingStatus['status'] | null>(null);

	const refetch = useCallback(async () => {
		const response = await fetchUserWalletStatus(username);

		setStatus(response);
		setLoading(false);
	}, [username]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, status, refetch, setLoading };
}

export default useUserWalletStatus;
